import React from "react";
import ReactDOM from "react-dom";
import RentingResultsModal from "./index";

export default async function renderRentingResultsModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<RentingResultsModal {...rest} />, domTarget);
  }
}
